module.exports = __webpack_public_path__ + "img/arrow_right_big.69541591.svg";